import APIService from "./APIService";

export default {
  getDadosTotaisRessarcimentoDanosEletricos(anoAtual, anoAnterior, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-dados-totais-ressarcimento-danos-eletricos?ano_atual=${anoAtual}&ano_anterior=${anoAnterior}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getValorPendenteSolicitacoesDeferidas(anoAtual, anoAnterior, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-valor-pendente-solicitacoes-deferidas?ano_atual=${anoAtual}&ano_anterior=${anoAnterior}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getValorPagoRessarcimentoDanosEletricos(anoAtual, anoAnterior, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-valor-pago-ressarcimento-danos-eletricos?ano_atual=${anoAtual}&ano_anterior=${anoAnterior}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getValorPendenteSolicitacoesDeferidasAcumulados(anoAtual, anoAnterior, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-valor-pendente-solicitacoes-deferidas-acumulados?ano_atual=${anoAtual}&ano_anterior=${anoAnterior}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getValorPagoRessarcimentoDanosEletricosAcumulados(anoAtual, anoAnterior, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-valor-pago-ressarcimento-danos-eletricos-acumulados?ano_atual=${anoAtual}&ano_anterior=${anoAnterior}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getDadosTotaisRessarcimentoDanosEletricosAcumulados(anoAtual, anoAnterior, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-dados-totais-ressarcimento-danos-eletricos-acumulados?ano_atual=${anoAtual}&ano_anterior=${anoAnterior}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getDadosTotaisRessarcimentoDanosEletricosVisaoMunicipios(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-dados-totais-ressarcimento-danos-eletricos-visao-municipios?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getValorPendenteSolicitacoesDeferidasVisaoMunicipios(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-valor-pendente-solicitacoes-deferidas-visao-municipios?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getValorPagoRessarcimentoDanosEletricosVisaoMunicipios(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-valor-pago-ressarcimento-danos-eletricos-visao-municipios?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },

  getKpisTotalizadosPorMunicipio(competenciaDe, competenciaAte, regional = 0) {
    return new Promise((resolve, reject) => {
      APIService.apiCall().get(`dashboard-ressarcimento-danos-eletricos/get-kpis-totalizado-por-municipio?competencia_de=${competenciaDe}&competencia_ate=${competenciaAte}&regional=${regional}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};